var exports = {
  "EM": "ProfileDecoration.module__decorated___LW4wTD",
  "Sp": "ProfileDecoration.module__themed___LW4wTD",
  "Qu": "ProfileDecoration.module__framed___LW4wTD",
  "ZO": "ProfileDecoration.module__aurora___LW4wTD",
  "bK": "ProfileDecoration.module__gold___LW4wTD",
  "lw": "ProfileDecoration.module__neon___LW4wTD",
  "bc": "ProfileDecoration.module__holographic___LW4wTD",
  "SO": "ProfileDecoration.module__ember___LW4wTD",
  "HP": "ProfileDecoration.module__frost___LW4wTD",
  "sL": "ProfileDecoration.module__sakura___LW4wTD",
  "Bm": "ProfileDecoration.module__midnight___LW4wTD",
  "_0": "ProfileDecoration.module__circuit___LW4wTD",
  "fW": "ProfileDecoration.module__pixel___LW4wTD",
  "i0": "ProfileDecoration.module__pcShift___LW4wTD",
  "V6": "ProfileDecoration.module__pcRise___LW4wTD",
  "Ke": "ProfileDecoration.module__pcSpin___LW4wTD",
  "_q": "ProfileDecoration.module__pcNeon___LW4wTD",
  "AR": "ProfileDecoration.module__pcPixel___LW4wTD",
};

module.exports = exports;
